import React from 'react';
import { AddUserProductConnectorApollo } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerAddUserProductContainer from './TrackerAddUserProductContainer';

const TrackerAddUserProductPage: React.FC = () => {
  const location = useLocation();

  return (
    <AddUserProductConnectorApollo>
      {({ addUserProduct }) => (
        <TrackerAddUserProductContainer addUserProduct={addUserProduct} key={location.key} />
      )}
    </AddUserProductConnectorApollo>
  );
};

export default TrackerAddUserProductPage;
